"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCivicGatewayProgramId = exports.getCivicGatewayProgram = exports.createCivicGatewayProgram = exports.CIVIC_GATEWAY_PROGRAM_ID = void 0;
const umi_1 = require("@metaplex-foundation/umi");
exports.CIVIC_GATEWAY_PROGRAM_ID = (0, umi_1.publicKey)('gatem74V238djXdzWnJf94Wo1DcnuGkfijbf3AuBhfs');
function createCivicGatewayProgram() {
    return {
        name: 'civicGateway',
        publicKey: exports.CIVIC_GATEWAY_PROGRAM_ID,
        getErrorFromCode: () => null,
        getErrorFromName: () => null,
        isOnCluster: () => true,
    };
}
exports.createCivicGatewayProgram = createCivicGatewayProgram;
function getCivicGatewayProgram(context, clusterFilter) {
    return context.programs.get('civicGateway', clusterFilter);
}
exports.getCivicGatewayProgram = getCivicGatewayProgram;
function getCivicGatewayProgramId(context, clusterFilter) {
    return context.programs.getPublicKey('civicGateway', exports.CIVIC_GATEWAY_PROGRAM_ID, clusterFilter);
}
exports.getCivicGatewayProgramId = getCivicGatewayProgramId;
//# sourceMappingURL=civicGateway.js.map